import QuestionFields from "pages/ManagementPage/candidateInfoForm/QuestionFields/QuestionFields";

export default QuestionFields;
